import module from 'fan/proyecto/module.js'
import template from './template.html'

const estados = [{id: true, descripcion: 'Activo'}, {id: false, descripcion: 'Inactivo'}]

const diacriticosRegex = /[,.\u0300-\u036f]/g
const diacriticosEspacios = /\s+\s/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').replace(diacriticosEspacios, ' ').toUpperCase().trim()

export class FanPlantillasGeneradorComponent {
  data = undefined
  onChange = undefined
  filtro = ''
  agrupaciones = []
  filtrados = []
  salas = []
  todosSeleccionados = false
  estados = estados
  estado = true
  departamento = undefined
  sala = undefined

  constructor ($filter) {
    this.filterBy = $filter('filter')
    this.groupBy = $filter('groupBy')
    this.orderBy = $filter('orderBy')
  }

  $onChanges (changes) {
    if (changes.data) {
      this.data = this.orderBy(this.data, ['agrupacion', 'descripcion'])
      this.data.forEach(item => {
        item.busqueda = normalizar(`${item.descripcion}|${item.data.id_colaborador}`)
        this.agrupaciones[item.agrupacion] = item.agrupacion
        this.salas[item.sala] = item.sala
      })

      this.agrupaciones = Object.values(this.agrupaciones)
      this.salas = Object.values(this.salas)
      this.filtrar()
    }
  }

  filtrar () {
    let filtro = normalizar(this.filtro)
    this.filtrados = this.data.filter(item => item.busqueda.contains(filtro)
      && (this.estado !== undefined ? item.activo === this.estado : true)
      && (this.departamento !== undefined ? item.agrupacion === this.departamento : true)
      && (this.sala !== undefined ? item.sala === this.sala : true),
    )
    this.totalizar()
  }

  seleccionar (item) {
    item.seleccionado = !item.seleccionado
    this.totalizar()
    this.notificar()
  }

  seleccionarTodos (seleccionado) {
    this.filtrados.forEach((item) => (item.seleccionado = seleccionado))
    this.totalizar()
    this.notificar()
  }

  totalizar () {
    this.todosSeleccionados = this.filtrados.length
      ? this.filtrados.every((item) => item.seleccionado)
      : undefined
  }

  notificar () {
    this.onChange({$data: this.data})
  }
}

module.component('fanPlantillasGenerador', {
  controller: FanPlantillasGeneradorComponent,
  template: template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/plantillas/components/generador/component.js